export default __webpack_public_path__ + "static/media/d30ccf2460aa5589.301e0d1d7f41ab7757318383502fcd67.svg";